import { useSearchParams, useParams } from 'react-router-dom';
import { useNoAuthGetProviderForm } from '../../api/hooks/provider/useNoAuthGetProviderForm';
import { Form, Formik } from 'formik';
import { useCreateDocumentation } from '../../api/documentation';
import FormBuilder from '../../components/form/FormBuilder';
import { NoteValue } from '../../provider/pages/PatientDetail/interfaces';
import { useState } from 'react';
import { FormTypes } from '../../provider/pages/Settings/Templates';
import DashboardLayout from '../../components/dashboard/DashboardLayout';

type FormField = {
	id: string;
	label: string;
	type: string;
	required: boolean;
	options?: Array<{ label: string; value: string }>;
};

type FormValues = {
	[key: string]: string;
};

const PatientFormPage = () => {
	const [consentFormAnswers, setConsentFormAnswers] = useState<NoteValue>(
		{} as NoteValue
	);
	const [searchParams] = useSearchParams();
	const { patientId, formType: formTypeParam } = useParams();
	const appointmentId = searchParams.get('appointmentId') || '';
	const providerId = searchParams.get('providerId') || '';
	const formType = formTypeParam === 'intake-form' ? ['intake'] : ['consent'] as [string, ...string[]];

	const { providerFormData } = useNoAuthGetProviderForm({
		formType: formType[0] === "intake" ? ['intakeForm'] : ['consentForm'],
		providerId,
	});

	const formFields = (providerFormData[0]?.data?.intakeForm?.noteFields || providerFormData[0]?.data?.consentForm?.noteFields) || [];


	const createDocumentation = useCreateDocumentation(appointmentId, formType as [string, ...string[]], patientId);


	return (
		<DashboardLayout headerTitle={`${formType[0].charAt(0).toUpperCase() + formType[0].slice(1)} Form`}>

			<div className='p-5'>
				<FormBuilder
					formParams={formFields}
					formType={formType[0] === "intake" ? 'intakeForm' : 'consentForm' as FormTypes}
					submitAction={() => createDocumentation.mutate(consentFormAnswers as Record<string, string>)}
					isPreview={false}
					setFormAnswers={setConsentFormAnswers}
					formAnswers={consentFormAnswers}
				/></div>
		</DashboardLayout>
	);
};

export default PatientFormPage;
